export const ActionTypes = {
	MOUNTED: 'MOUNTED',
	VISITS_GET: 'VISITS_GET',
	NAVIGATE_SETUP: 'NAVIGATE_SETUP',
	INSTRUCTIONS_TOGGLE: 'INSTRUCTIONS_TOGGLE',
	FEATURES_GET: 'FEATURES_GET',
	COUNTERS_GET: 'COUNTERS_GET'
};
